import {create} from 'zustand';
import {type FaceLandmarksDetector} from '@tensorflow-models/face-landmarks-detection';

interface LivenessModelsState {
  isLoading: boolean;
  isWebGLSupported: boolean;
  detector: FaceLandmarksDetector | null;
}

interface LivenessModelsStore extends LivenessModelsState {
  setIsLoading: (value: boolean) => void;
  setIsWebGLSupported: (value: boolean) => void;
  setDetector: (value: FaceLandmarksDetector | null) => void;
}

const INITIAL_STATE: LivenessModelsState = {
  isLoading: false,
  isWebGLSupported: false,
  detector: null,
};

export const useLivenessModelsStore = create<LivenessModelsStore>(set => ({
  ...INITIAL_STATE,

  setIsLoading: isLoading => set({isLoading}),

  setDetector: detector => set({detector}),

  setIsWebGLSupported: isWebGLSupported => set({isWebGLSupported}),
}));
